<ng-container *ngIf="!isMobileView">
    <div class="row mt-3">
        <div class="col-xl-4 col-md-4">
            <h4 style="float: left;"><span class="bold">{{offerDetails}}</span>
                :{{electricComparatorResult.denumire_oferta}}</h4>
        </div>
    </div>
    <div class="row detalii-comparator-electric">
        <div class="col-sm shadow m-3 p-3 mb-5 bg-white label-bold rounded">
            <div class="form-group row">
                <p><b>{{offerType}}</b>
                    {{electricComparatorResult.tip_oferta}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{productType}}</b>
                    {{electricComparatorResult.tip_produs}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{clientType}}</b>
                    {{electricComparatorResult.tip_client}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{offerpriceType}}</b>
                    {{electricComparatorResult.tip_pret_oferta}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{offerValability}}</b>
                    {{electricComparatorResult.valabilitate_oferta_start}} -
                    {{electricComparatorResult.valabilitate_oferta_stop}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{applicationPeriod}}</b>
                    {{electricComparatorResult.perioada_de_aplicare_start}} -
                    {{electricComparatorResult.perioada_de_aplicare_stop}}</p>
            </div>
        </div>
        <div class="col-sm shadow m-3 p-3 mb-5 label-bold bg-white rounded">
            <div class="form-group row">
                <p><b>{{supplyPrice}}
                        {{onConvertToNumber(onConvertToNumber(electricComparatorResult.pret_energie) +
                        onConvertToNumber(electricComparatorResult.tarif_transport_tl) +
                        onConvertToNumber(electricComparatorResult.tarif_serviciu_sistem) +
                        onConvertToNumber(electricComparatorResult.tarif_serviciu_distributie),5) }}
                        ({{electricComparatorResult.unitate_masura}}), din care:</b></p>
                <p style="text-align: right;">
                    - Pret energie - inclusiv Tg ({{electricComparatorResult.unitate_masura }}):
                    {{electricComparatorResult.pret_energie}}
                </p>
                <p style="text-align: right;">
                    - Tarif transport TL ({{electricComparatorResult.unitate_masura }}):
                    {{electricComparatorResult.tarif_transport_tl}}
                </p>
                <p style="text-align: right;">
                    - Tarif serviciu sistem ({{electricComparatorResult.unitate_masura }}):
                    {{electricComparatorResult.tarif_serviciu_sistem}}
                </p>
                <p style="text-align: right;">
                    - Tarif serviciu distributie ({{electricComparatorResult.unitate_masura }}):
                    {{electricComparatorResult.tarif_serviciu_distributie}}
                </p>
            </div>
            <div class="form-group row">
                <p><b>{{fixedComponent}}</b>
                    {{electricComparatorResult.valoare_componenta_fixa}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{cogenerationTax}}</b>
                    {{onConvertToNumber(electricComparatorResult.taxa_cogenerare_inalta_eficienta)}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{certifiedGreenValue}}</b>
                    {{electricComparatorResult.contravaloare_certificate_verzi}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{excise}}</b>
                    {{electricComparatorResult.acciza}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{tva}}</b>
                    {{electricComparatorResult.tva}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{invoiceUnitValue}}</b>
                    {{electricComparatorResult.pret_final}}</p>
            </div>
        </div>
        <div class="col-sm shadow m-3 p-3 mb-5 bg-white label-bold rounded">
            <div class="form-group row">
                <p><b>{{contractPeriod}}</b>
                    {{electricComparatorResult.perioada_contract}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{paymentDeadline}}</b>
                    {{electricComparatorResult.termen_plata}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{invoiceSubmissionMethod}}</b>
                    {{electricComparatorResult.mod_transmitere_factura}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{invoiceFrequency}}</b>
                    {{electricComparatorResult.frecventa_emitere_factura}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{meterReadingFrequency}}</b>
                    {{electricComparatorResult.frecventa_citire_contor}}
                </p>
            </div>
            <div class="form-group row">
                <p><b>{{contractModel}}</b>
                    <a href="{{comparatorDocumentsUrl + electricComparatorResult.model_contract}}"
                        target="_blank">Descarca</a>
                </p>
            </div>
            <div class="form-group row">
                <p><b>{{otherCosts}}</b>
                    {{electricComparatorResult.alte_costuri}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{electricityAcquisition}} {{electricComparatorResult.an_achizitie_energie}}</b><br>
                    - Gaz: {{electricComparatorResult.structura_achizitie_energetica?.gaz}}%<br>
                    - Hidro: {{electricComparatorResult.structura_achizitie_energetica?.hidro}}%<br>
                    - Nucleara: {{electricComparatorResult.structura_achizitie_energetica?.nucleara}}%<br>
                    - Vant: {{electricComparatorResult.structura_achizitie_energetica?.vant}}%<br>
                    - Solar: {{electricComparatorResult.structura_achizitie_energetica?.solar}}%<br>
                    - Altele: {{electricComparatorResult.structura_achizitie_energetica?.altele}}%<br>
            </div>
            <div class="form-group row">
                <p><b>{{discountsApplied}}</b>
                    {{electricComparatorResult.reduceri}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{applicationPeriodDiscount}}</b>
                    {{electricComparatorResult.perioada_reduceri_min}} -
                    {{electricComparatorResult.perioada_reduceri_max}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{additionalServicesIncluded}}</b>
                    {{electricComparatorResult.servicii_aditionale_incluse}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{otherConditions}}</b>
                    {{electricComparatorResult.alte_conditii}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{lastupdate}}</b>
                    {{electricComparatorResult.ultima_actualizare}}</p>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="isMobileView">
    <div class="row">
        <div class="col-sm shadow m-3 p-3 mb-5 bg-white label-bold rounded">
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label><a href="{{electricComparatorResult.legatura_oferta}}"
                            target="_blank">{{electricComparatorResult.nume_furnizor}}</a></label>
                    <a style="float:right" href="javascript:void(0);" class="show-button" (click)="showDetails()">
                        <img *ngIf="!isDetailsExpanded" src="../../../../assets/images/arrow-down.png" width="32">
                        <img *ngIf="isDetailsExpanded" src="../../../../assets/images/arrow-up.png" width="32">
                    </a>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md mb-2" *ngIf="isSelectOfferButtonVisible">
                  <button class="btn btn-info btn-rounded" (click)="selectOfferChange.emit()">{{selectOffer}}</button>
                </div>
                <div class="col-xl col-md">
                    <label>{{offerName}}</label>
                </div>
                <div class="col-xl col-md">
                    <a href="{{electricComparatorResult.oferta_pdf}}"
                        target="_blank">{{electricComparatorResult.denumire_oferta}}</a>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{offerType}}</label>
                </div>
                <div class="col-xl col-md">
                    <span>{{electricComparatorResult.tip_oferta}}</span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{renewableEnergy}}</label>
                </div>
                <div class="col-xl col-md">
                    <ng-container *ngIf="+electricComparatorResult.procent_energie_surse_regenerabile > 0">
                        <img src="../../../../assets/images/leaf.png" width="32"><br />
                    </ng-container>
                    <span>{{electricComparatorResult.procent_energie_surse_regenerabile}}%</span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{invoiceValue}}</label>
                </div>
                <div class="col-xl col-md">
                    <span>{{electricComparatorResult.valoare_factura_furnizor_fc}}</span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{invoiceUnitValue}}</label>
                </div>
                <div class="col-xl col-md">
                    <span>{{electricComparatorResult.pret_final}}</span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{invoiceValueComparison}}</label>
                </div>
                <div class="col-xl col-md">
                    <span class="red"
                        *ngIf="!comparatorForm.controls.currentInvoiceValue.value">{{fillInTheCurrentInvoiceValue}}</span>
                    <span [ngClass]="{'green': onConvertToNumber(electricComparatorResult.rezultat_comparatie_valoare_factura) <= 0,
                    'red': onConvertToNumber(electricComparatorResult.rezultat_comparatie_valoare_factura) > 0}"
                        *ngIf="comparatorForm.controls.currentInvoiceValue.value">
                        <span
                            *ngIf="onConvertToNumber(electricComparatorResult.rezultat_comparatie_valoare_factura) <= 0">
                            ⇓
                        </span>
                        <span
                            *ngIf="onConvertToNumber(electricComparatorResult.rezultat_comparatie_valoare_factura) > 0">
                            ⇑
                        </span>
                        {{electricComparatorResult.rezultat_comparatie_valoare_factura}} %</span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{economyCost}}</label>
                </div>
                <div class="col-xl col-md">
                    <span class=" red"
                        *ngIf="!comparatorForm.controls.currentInvoiceValue.value">{{fillInTheCurrentInvoiceValue}}</span>
                    <span [ngClass]="{'green': onConvertToNumber(electricComparatorResult.rezultat_economie_cost) < 0,
                    'red': onConvertToNumber(electricComparatorResult.rezultat_economie_cost) >= 0}"
                        *ngIf="comparatorForm.controls.currentInvoiceValue.value">
                        <span *ngIf="onConvertToNumber(electricComparatorResult.rezultat_economie_cost) <= 0"> ⇓
                        </span>
                        <span *ngIf="onConvertToNumber(electricComparatorResult.rezultat_economie_cost) > 0"> ⇑
                        </span>
                        {{electricComparatorResult.rezultat_economie_cost}}</span>
                </div>
            </div>
            <ng-container *ngIf="isDetailsExpanded">
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <h4><span>{{offerDetails}}:</span>
                            <span>{{electricComparatorResult.denumire_oferta}}</span>
                        </h4>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{offerType}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.tip_oferta}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{productType}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.tip_produs}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{clientType}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.tip_client}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label class="mr-3">{{offerpriceType}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span> {{electricComparatorResult.tip_pret_oferta}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label class="mr-3">{{offerValability}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.valabilitate_oferta_start}} -
                            {{electricComparatorResult.valabilitate_oferta_stop}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{applicationPeriod}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.perioada_de_aplicare_start}} -
                            {{electricComparatorResult.perioada_de_aplicare_stop}}</span>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{supplyPrice}} {{onConvertToNumber(electricComparatorResult.pret_energie,5) +
                            onConvertToNumber(electricComparatorResult.tarif_transport_tl,5) +
                            onConvertToNumber(electricComparatorResult.tarif_serviciu_sistem,5) +
                            onConvertToNumber(electricComparatorResult.tarif_serviciu_distributie,5) }}
                            ({{electricComparatorResult.unitate_masura}}), din care:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>
                            - Pret energie - inclusiv Tg ({{electricComparatorResult.unitate_masura }}):
                            {{electricComparatorResult.pret_energie}} ({{electricComparatorResult.unitate_masura }})<br>
                            - Tarif transport TL ({{electricComparatorResult.unitate_masura }}):
                            {{electricComparatorResult.tarif_transport_tl}} ({{electricComparatorResult.unitate_masura
                            }})<br>
                            - Tarif serviciu sistem ({{electricComparatorResult.unitate_masura }}):
                            {{electricComparatorResult.tarif_serviciu_sistem}}
                            ({{electricComparatorResult.unitate_masura
                            }})<br>
                            - Tarif serviciu distributie ({{electricComparatorResult.unitate_masura }}):
                            {{electricComparatorResult.tarif_serviciu_distributie}}
                            ({{electricComparatorResult.unitate_masura}})<br>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{fixedComponent}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.valoare_componenta_fixa}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{cogenerationTax}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{onConvertToNumber(electricComparatorResult.taxa_cogenerare_inalta_eficienta)}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{certifiedGreenValue}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.contravaloare_certificate_verzi}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{excise}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.acciza}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{tva}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.tva}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{invoiceUnitValue}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.pret_final}}</span>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{contractPeriod}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.perioada_contract}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{paymentDeadline}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.termen_plata}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{invoiceSubmissionMethod}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.mod_transmitere_factura}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{invoiceFrequency}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.frecventa_emitere_factura}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{meterReadingFrequency}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.frecventa_citire_contor}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{contractModel}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <a href="{{comparatorDocumentsUrl + electricComparatorResult.model_contract}}"
                            target="_blank">Descarca</a>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{otherCosts}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.alte_costuri}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{electricityAcquisition}} {{electricComparatorResult.an_achizitie_energie}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>
                            - Gaz: {{electricComparatorResult.structura_achizitie_energetica?.gaz}}%<br>
                            - Hidro: {{electricComparatorResult.structura_achizitie_energetica?.hidro}}%<br>
                            - Nucleara: {{electricComparatorResult.structura_achizitie_energetica?.nucleara}}%<br>
                            - Vant: {{electricComparatorResult.structura_achizitie_energetica?.vant}}%<br>
                            - Solar: {{electricComparatorResult.structura_achizitie_energetica?.solar}}%<br>
                            - Altele: {{electricComparatorResult.structura_achizitie_energetica?.altele}}%<br>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{discountsApplied}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.reduceri}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{applicationPeriodDiscount}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.perioada_reduceri_min}} -
                            {{electricComparatorResult.perioada_reduceri_max}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{additionalServicesIncluded}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.servicii_aditionale_incluse}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{otherConditions}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.alte_conditii}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{lastupdate}}</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{electricComparatorResult.ultima_actualizare}}</span>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>
